import React from 'react'

import useNavbarFlatGround from '@/hooks/useNavbarFlatGround'
import MarketShareFollow from '@/features/market/share-follow'

import './MarketStickyBar.scss'

/**
 * Condensed market header for the desktop market page.
 *
 * Slides in under the navbar once the full header has scrolled out of view so
 * the title and the share/follow controls stay reachable for the rest of the
 * page. Hidden state relies on `visibility` so the buttons leave the tab order.
 */
const MarketStickyBar = ({ question, visible = false }) => {
  useNavbarFlatGround(visible)

  if (!question) return null

  return (
    <div className={`market-sticky-bar${visible ? ' market-sticky-bar--visible' : ''}`} aria-hidden={!visible}>
      <div className="market-sticky-bar__inner">
        <span className="market-sticky-bar__title" title={question.title}>
          {question.title}
        </span>
        <MarketShareFollow question={question} inMarketPage />
      </div>
    </div>
  )
}

export default MarketStickyBar
